<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgb(18, 18, 18);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorWorshop .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorWorshop .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorWorshop .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
</style>
<template>
  <div style="display: inline;">
    <div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
      <div ref="header" style="">
        <!-- <div class="module-grid" style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;">
          <div style="width: 340px;cursor: pointer;">
            <img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 176px;height: 38px;" src="../../../../../../assets/img/web/workshop/logo.png" />
          </div>
          <div style="font-weight: 700;font-size: 30px;color: white;">{{ store.state.customer.shortName }}-{{ $t('MESzonghekanban') }}</div>
          <div class="monitorWorshop" style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
            <p style="font-size: 14px;color:white;">{{ store.state.currentTime }}</p>
          
          </div>
        </div> -->
      </div>
      <div>
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false" :vertical-compact="false" :margin="[0, 0]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: hidden;">
          <grid-item @resized="resizedGrid" v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component :cockpitData="cockpitData" :ref="'grid_' + item.i" v-bind:is="item.i"> </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import VueGridLayout from 'vue-grid-layout';
import machine from '@@/pages/web/customize/yongxin/monitor/mes/machine/index.vue';
import model from '@@/pages/web/customize/yongxin/monitor/mes/model/index.vue';
import andeng from '@@/pages/web/customize/yongxin/monitor/mes/andeng/index.vue';
import production from '@@/pages/web/customize/yongxin/monitor/mes/production/index.vue';
import quality_analysis from '@@/pages/web/customize/yongxin/monitor/mes/quality_analysis/index.vue';
import liaodou from '@@/pages/web/customize/yongxin/monitor/mes/liaodou/index.vue';
import lengshuiji from '@@/pages/web/customize/yongxin/monitor/mes/lengshuiji/index.vue';
import equipment from '@@/pages/web/customize/yongxin/monitor/mes/equipment/index.vue';
import error from '@@/pages/web/customize/yongxin/monitor/mes/error/index.vue';
import quality from '@@/pages/web/customize/yongxin/monitor/mes/quality/index.vue';

import energy from '@@/pages/web/customize/yongxin/monitor/mes/energy/index.vue';
export default {
  name: 'web_customize_yongxin_monitor_mes_index',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    machine: machine,
    model: model,
    energy: energy,
    quality_analysis: quality_analysis,
    production: production,
    andeng: andeng,
    liaodou: liaodou,
    lengshuiji: lengshuiji,
    equipment: equipment,
    error: error,
    quality: quality
  },

  data() {
    return {
      cockpitData: {},
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      layout: []
    };
  },
  watch: {
    orgId(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
    }
  },
  created() {
    this.setLayout();
  },
  activated() {
    this.resize();
  },
  mounted() {
   /* setInterval(() => {
      console.log(this.layout);
    }, 5000);*/
    this.resize();

    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timmer) {
      clearInterval(this.timmer);
    }
  },
  methods: {
    setLayout() {
      this.layout = [
        // {
        //   x: 0,
        //   y: 0,
        //   w: 24,
        //   h: 24,
        //   i: 'energy'
        // },
        {
          x: 0,
          y: 0,
          w: 8,
          h: 8, //应该是6
          i: 'machine'
        },
        {
          x: 8,
          y: 0,
          w: 8,
          h: 8, //应该是6
          i: 'production'
        },
        {
          x: 16,
          y: 0,
          w: 8,
          h: 8,
          i: 'energy'
        },
        {
          x: 0,
          y: 8,
          w: 8,
          h: 8, //应该是6
          i: 'model'
        },
        {
          x: 8,
          y: 8,
          w: 8,
          h: 8, //应该是6
          i: 'quality'
        },
        {
          x: 16,
          y: 8,
          w: 8,
          h: 8, //应该是6
          i: 'lengshuiji'
        },
        {
          x: 0,
          y: 16,
          w: 8,
          h: 8, //应该是6
          i: 'error'
        },
        {
          x: 8,
          y: 16,
          w: 8,
          h: 8, //应该是6
          i: 'equipment'
        },
        {
          x: 16,
          y: 16,
          w: 8,
          h: 8, //应该是6
          i: 'liaodou'
        }
      ];
    },

    resizedGrid(i) {
      this.$refs['grid_' + i][0].resize();
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight;
        this.gridRowHeihgt = this.gridContainerHeight / 24;

        for (let index = 0; index < this.layout.length; index++) {
          let layout = this.layout[index];
          this.resizedGrid(layout.i);
        }
        // setTimeout(() => {

        //   this.resizedGrid('model');
        //   this.resizedGrid('machine');
        //   this.resizedGrid('row');
        //   this.resizedGrid('energy');
        //   this.resizedGrid('quality_analysis');
        // }, 2000);
      }, 500);
    }
  }
};
</script>
